import {getCustomFilters} from "./customFilters";
import {defineMessages} from "react-intl";

const messages = defineMessages({
    "created_at": {
        id: 'invoice.listing.filters.date.created_at',
        defaultMessage: 'Created date',
    },
    "total_amount": {
        id: "invoice.listing.headers.total_amount",
        defaultMessage: "Amount",
    },
})

export const externalOrderTotals = [
    'totalAmount'
]

export const externalOrderFields = [
    'identifier',
    'identifierKeyword',
    'identifierAnalyzed',
    'identifierNumber',
]

export const getExternalOrderFilters = function (context) {
    var newFilters = getCustomFilters(context,"externalOrders")
    var filtersToUse =
        [
            {
                nameId: 'createdAt',
                label: context.intl.formatMessage(messages["created_at"]),
                filterMatch: 'createdAt',
                type: 'date',
                initialValue: {startDate: null, endDate: null},
                initialSelect: 'is'
            },
            {
                nameId: 'amount',
                label: context.intl.formatMessage(messages["total_amount"]),
                nameField: 'totalAmount',
                filterMatch: 'totalAmount',
                type: 'number',
                initialValue: '',
                initialSelect: 'is'
            },
        ]

    return filtersToUse.concat(newFilters)
}



// WEBPACK FOOTER //
// ./src/common/search-filter/search/externalOrderFilters.jsx